import React, {useEffect, useState} from "react";
import Plot from "react-plotly.js";
import AlertInfo from "../../ui/AlertInfo";

export default function ClusterTapThroughputChart(props) {

  const cluster = props.cluster;
  const height = props.height;
  const colors = props.colors;
  const xAxis = props.xAxis;
  const yAxis = props.yAxis;
  const margins = props.margins;

  const [throughputData, setThroughputData] = useState(null);

  useEffect(() => {
    const x = [];
    const y = [];

    let allEmpty = true;
    cluster.tap_throughput.forEach((t) => {
      if (t.value > 0) {
        allEmpty = false;
      }

      x.push(new Date(t.bucket));
      y.push(t.value / 1024 / 1024);
    })

    setThroughputData({x: x, y: y, empty: allEmpty});
  }, [cluster]);

  if (throughputData == null) {
    return null;
  }

  if (throughputData.empty) {
    return <AlertInfo>No Throughput Data Available</AlertInfo>
  }

  return <Plot
          style={{ width: "100%", height: height }}
          data={[
            {
              x: throughputData.x,
              y: throughputData.y,
              type: "bar",
              marker: {size: 3, color: colors.bar}
            }
          ]}
          layout={{
            margin: margins,
            paper_bgcolor: "rgba(0,0,0,0)",
            plot_bgcolor: "rgba(0,0,0,0)",
            font: {
              family: "Geist, sans-serif",
              size: 12,
              color: '#9a9ab0'
            },
            hoverlabel: {
              bgcolor: "#25252d",
              bordercolor: "#33333d",
              font: {
                family: "Geist, sans-serif",
                size: 12,
                color: '#e8e8ed'
              }
            },
            showlegend: false,
            dragmode: false,
            clickmode: "none",
            hovermode: "x+y",
            xaxis: {
              fixedrange: true,
              linecolor: xAxis.lineColor,
              linewidth: xAxis.lineWidth,
              gridcolor: xAxis.gridColor,
              zeroline: false,
              tickfont: {
                family: "Geist Mono, monospace",
                size: 11,
                color: '#9a9ab0'
              }
            },
            yaxis: {
              ticksuffix: " Mbit/sec",
              tickformat: ".2~f",
              fixedrange: true,
              linecolor: yAxis.lineColor,
              linewidth: yAxis.lineWidth,
              gridcolor: yAxis.gridColor,
              zeroline: false,
              tickfont: {
                family: "Geist Mono, monospace",
                size: 11,
                color: '#9a9ab0'
              }
            }
          }}
          useResizeHandler
          config={{
            displayModeBar: false,
            autosize: true,
            responsive: true
          }}
      />

}
